import type SignalFilters from "../../../models/core/SignalFilters";
import type SignalTemplate from "../../../models/templates/SignalTemplate";
import SignalTemplatesManager from "../../../models/templates/SignalTemplatesManager";

export default class ComingSoonSignalTemplatesManager extends SignalTemplatesManager<SignalFilters> {
    getTemplates(): readonly SignalTemplate<SignalFilters>[] {
        return [];
    }

    getDefaultTemplate(): SignalTemplate<SignalFilters> {
        throw new Error("Coming soon signal types do not have templates");
    }

    getEmptyTemplate(): SignalTemplate<SignalFilters> {
        throw new Error("Coming soon signal types do not have templates");
    }
}
